import { Form, Grid, Input, Fieldset, Note, Tabs } from '@common'
import { VENDOR_FORM_ID } from '@constants'
import { useVendorForm, VendorFormProps } from './useVendorForm'
import StagedVendorAttachmentEditor from './StagedVendorAttachmentEditor'
import { StagedAttachment } from '@api/attachments/models/Attachment.model'
import { useState } from 'react'

const VendorForm = ({
  isEdit,
  initialValues,
  handleSubmit,
  canEdit = true,
}: VendorFormProps) => {
  const [stagedAttachments, setStagedAttachments] = useState<StagedAttachment[]>([])

  const { getField, handleFormSubmit, currentVendorID } = useVendorForm({
    initialValues,
    handleSubmit,
    canEdit,
    stagedAttachments,
  })

  return (
    <Form id={VENDOR_FORM_ID} onSubmit={handleFormSubmit} noValidate>
      <Grid>
        <Grid.Item>
          <Input {...getField('VN_VEN_ID')} autoFocus={!isEdit} disabled={isEdit} />
        </Grid.Item>

        <Grid.Item>
          <Input {...getField('VN_NAME')} autoFocus={isEdit} />
        </Grid.Item>
        <Grid.Item>
          <Tabs>
            <Tabs.Item title="Vendor Information">
              <Grid>
                <Grid.Item>
                  <Input {...getField('VN_STREET')} />
                </Grid.Item>
                <Grid.Item s={9}>
                  <Input {...getField('VN_CITY')} />
                </Grid.Item>
                <Grid.Item s={3}>
                  <Input {...getField('VN_STATE')} helper="2 character code" />
                </Grid.Item>
                <Grid.Item>
                  <Input {...getField('VN_CNTY')} />
                </Grid.Item>
                <Grid.Item>
                  <Input {...getField('VN_ZIP')} />
                </Grid.Item>
              </Grid>
            </Tabs.Item>
            <Tabs.Item title="Contact Information">
              <Grid>
                <Grid.Item>
                  <Input {...getField('VN_PHONE')} />
                </Grid.Item>
                <Grid.Item>
                  <Input {...getField('VN_FAX')} />
                </Grid.Item>
              </Grid>
            </Tabs.Item>
            <Tabs.Item title="Attachments">
              <StagedVendorAttachmentEditor
                vendorID={currentVendorID}
                canEdit={canEdit}
                stagedAttachments={stagedAttachments}
                onStagedAttachmentsChange={setStagedAttachments}
                attachmentType="Vendor"
              />
            </Tabs.Item>
          </Tabs>
        </Grid.Item>
        {!isEdit && (
          <Grid.Item>
            <Note intent="warning" content={'ID cannot be changed once vendor is added.'} />
          </Grid.Item>
        )}
      </Grid>
    </Form>
  )
}
export default VendorForm
